import React from 'react'
import Grupos from '../components/Grupos'

const grupos = () => {
  return (
    <Grupos />
  )
}

export default grupos